import { configureStore } from "@reduxjs/toolkit";

import cart from "../redux/slices/cartSlice";
import menu from "../redux/slices/MenuSlice";
import auth from "../redux/slices/authSlice";
export const store = configureStore({
  reducer: {
    cart,
    menu,
    auth,
  },
});
